import { useState } from 'react'
import { Link } from 'react-router-dom'

import iconGuardar from '../img/iconGuardar.svg'
import iconVistaPrevia from '../img/iconVistaPrevia.svg'

import { useInvoices } from '../../../hooks/useInvoices'
import { Model } from '../../../models/model'
import { useCobros } from '../../../hooks/useCobros'

import { DialogDelete } from '../anular/DialogDelete'
import { CobrosDialogForm } from '../../cobros/form/CobrosDialogForm';
import { CobrosDialogList } from '../../cobros/CobrosDialogList';
import { DialogAnular } from '../anular/DialogAnular'
import VistaPrevia from '../vistaPreviaPdf/VistaPrevia'

import { emit } from "../../../utils/eventBus";

export const FormActions = ({ checkInitialData, setForm, dataForm, setOpenExtendedMode, loadIniBudget }) => {

    const { initSaveInvoice } = useInvoices()
    const { detailCobro, initCreateNewCobro } = useCobros()
    const { id, cobros, estado } = dataForm

    const [openDelete, setOpenDelete] = useState(false)
    const [openModalCobros, setOpenModalCobros] = useState(false)
    const [openCobrosDialogList, setOpenCobrosDialogList] = useState(false)
    const [openAnular, setOpenAnular] = useState(false)

    const [openPreview, setOpenPreview] = useState(false)

    const handleSave = async (e) => {
        e.preventDefault()

        if (parseFloat(id) > 0) {

            await Model.update({
                url: `invoices/${id}`,
                dataForm: dataForm
            })

            emit("flows_updated");

            const dataOne = await Model.getOne({
                url: `invoices/${id}`
            })

            setForm(dataOne)

        } else {
            await initSaveInvoice(dataForm, loadIniBudget)
            emit("flows_updated");
            setOpenExtendedMode(false)
        }


    }

    const handleVerCobros = () => {
        setOpenCobrosDialogList(true);
    }

    const handleAddCobro = async () => {
        await initCreateNewCobro(dataForm)
        setOpenModalCobros(true)
    }

    const handlePreview = () => {
        setOpenPreview(true)
    }

    return (
        <>

            {openPreview &&
                <VistaPrevia
                    open={openPreview}
                    setOpen={setOpenPreview}
                    dataPreview={dataForm}
                />
            }

            {openCobrosDialogList &&
                <CobrosDialogList
                    title='Cobros realizados'
                    openModal={openCobrosDialogList}
                    setModal={setOpenCobrosDialogList}
                    dataFactura={dataForm}
                    checkInitialData={checkInitialData}
                />
            }

            {openModalCobros &&
                <CobrosDialogForm
                    initialData={detailCobro}
                    title='Nuevo cobro'
                    openModal={openModalCobros}
                    setModal={setOpenModalCobros}
                    dataFactura={dataForm}
                    checkInitialData={checkInitialData}
                />
            }

            {openDelete &&
                <DialogDelete
                    invoiceId={id}
                    open={openDelete}
                    setOpen={setOpenDelete}
                />
            }

            {openAnular &&
                <DialogAnular
                    setForm={setForm}
                    dataForm={dataForm}
                    open={openAnular}
                    setOpen={setOpenAnular}
                    checkInitialData={checkInitialData}
                />
            }

            <div className='row'>
                <div className="col-8 d-flex">

                    {/* {(estado !== 'anulada' && estado !== 'pagada') && */}
                    {(estado !== 'anulada') &&
                        <button className='btn p-btn-secondary d-flex align-items-center' onClick={handleSave}>
                            <img src={iconGuardar} alt='guardar' />
                            <span>Guardar</span>
                        </button>
                    }

                    {(id > 0 && id !== null && estado !== 'anulada') &&
                        <button className='btn p-btn-secondary d-flex align-items-center' onClick={handlePreview}>
                            <img src={iconVistaPrevia} alt='vista previa' />
                            <span>Vista previa</span>
                        </button>
                    }

                    {(id > 0 && id !== null && estado !== 'anulada' && estado !== 'pagada' && estado !== 'por emitir') &&
                        <button className='btn p-btn-secondary d-flex align-items-center' onClick={handleAddCobro}>
                            <i className="bi bi-plus"></i>
                            <span style={{ marginLeft: '8px' }}>Cobrar</span>
                        </button>
                    }

                    {estado === 'emitida' &&
                        < button
                            className='btn p-btn-secondary d-flex align-items-center'
                            onClick={() => setOpenAnular(true)}>
                            <i className="bi bi-x-circle"></i>
                            <span style={{ marginLeft: '8px' }}>Anular</span>
                        </button>
                    }

                    {(id > 0 && id !== null && estado !== 'anulada' && estado !== 'pagada') &&
                        <button
                            className='btn p-btn-secondary d-flex align-items-center'
                            onClick={() => setOpenDelete(true)}>
                            <i className="bi bi-trash3"></i>
                            {/* <span style={{ marginLeft: '8px' }}>Eliminar</span> */}
                        </button>
                    }

                </div>

                <div className="col-4 d-flex justify-content-end align-items-center">
                    {(cobros && cobros.length > 0 &&
                        <Link to='#' className='link pagos' onClick={handleVerCobros}>Ver cobros</Link>)
                    }
                </div>

            </div >

        </>

    )
}